import styled from 'styled-components'

export const RootWrapper = styled.div`
  padding: 2.688rem 1.75rem 2.25rem;
  width: 31.188rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ModalTitle = styled.h2`
  color: #002855;
  font-family: Molde-regular;
  font-size: 1.625rem;
  text-align: center;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 2rem;
`

export const ModalParagraph = styled.p`
  margin-top: 0.75rem;
  color: #555555;
  font-family: Molde-regular;
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
`
export const WarningText = styled(ModalParagraph)`
  margin-top: 0rem;
  color: #b8002f;
  font-weight: 500;
`

export const CheckWrapper = styled.div`
  color: #555555;
  font-family: Molde-regular;
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 22px;
`

export const ButtonContainer = styled.div`
  margin-top: 1.5rem;
`
const Button = styled.button`
  height: 2.688rem;
  width: 10.313rem;
  border-radius: 5px;
  margin-left: 0.75rem;
  font-family: Molde-regular;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
`

export const DeleteAccountButton = styled(Button)`
  color: #ffffff;
  background-color: #b8002f;
  border-width: 0px;
  :disabled {
    background-color: #909090;
  }
`

export const CancelButton = styled(Button)`
  box-sizing: border-box;
  border: 2px solid #999999;
  background-color: #ffffff;
  color: #555555;
`
